module.exports = __webpack_public_path__ + "static/media/digited_logo_wihte.d8d8fb61.png";